<template>
  <div>
    <el-upload v-if="type === 'image'" class="avatar-uploader" action="" :show-file-list="false"
      :before-upload="beforeUpload">
      <img v-if="val" :src="val" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <div style="color: #999;font-size: 12px;margin-top: -20px">{{ tip }}</div>
  </div>
</template>

<script>
import { upload } from "@/api/upload";
export default {
  props: {
    type: {
      type: String,
      default: "image",
    },
    value: {
      type: String,
      default: "",
    },
    tip: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      val: "",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.val = val;
      },
      immediate: true,
    },
  },
  methods: {
    beforeUpload(file) {
      const [type] = file.type.split("/");
      if (type != "image") {
        this.$message.warning("请上传图片文件");
        return;
      }
      upload(file).then(({ code, message, result }) => {
        if (code == 200) {
          this.val = result;
          this.$emit("input", this.val);
        } else {
          this.$message.error(message);
        }
      });
      return false;
    },
  },
};
</script>

<style></style>